<div class="upload-button">
  <button
    color="primary"
    class="button-next"
    [disabled]="isReadAdmin"
    (click)="selectDocument()"
    data-cy="button-attach-document"
    mat-raised-button>
    <span>Upload Document</span>
  </button>
</div>
<div class="doc-list">
  <table [dataSource]="dataSource" class="fc-table" mat-table matSort aria-describedby="List of Site Documents">
    <ng-container matColumnDef="uploadedBy">
      <th scope="col" *matHeaderCellDef mat-header-cell class="column-medium">
        <div mat-sort-header="uploadedBy">Uploaded By
          <fa-icon [icon]="sortIcon('uploadedBy')"></fa-icon>
        </div>
        @if (uploadedByOptions.length > 1) {
          <mat-form-field>
            <mat-select
              [(value)]="documentFilters.uploadedBy"
              (selectionChange)="applyFilters()"
              placeholder="Filter"
              multiple>
              @for (uploader of uploadedByOptions; track uploader) {
                <mat-option [value]="uploader">
                  {{ uploader }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </th>
      <td *matCellDef="let element" mat-cell class="column-medium">
        <div class="doc-name">{{ element.user?.getDisplayName({ includeEmail: false }) }}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="added">
      <th scope="col" *matHeaderCellDef mat-header-cell class="column-medium">
        <div mat-sort-header="added">Date Added
          <fa-icon [icon]="sortIcon('added')"></fa-icon>
        </div>
      </th>
      <td *matCellDef="let element" mat-cell class="column-medium">
        <div class="doc-name">{{ element.createDate | date: 'short' }}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="title">
      <th scope="col" *matHeaderCellDef mat-header-cell>
        <div mat-sort-header="title">Document Title
          <fa-icon [icon]="sortIcon('title')"></fa-icon>
        </div>
        @if (isAdmin || activeSite?.submittedDate) {
          <mat-form-field>
            <input
              [(ngModel)]="documentFilters.title"
              (input)="applyFilters()"
              matInput
              placeholder="Filter" />
          </mat-form-field>
        }
      </th>
      <td *matCellDef="let element" mat-cell>
        <div class="doc-name">{{ element.name }}</div>
        <div class="doc-description">{{ element.description }}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th scope="col" *matHeaderCellDef mat-header-cell class="column-large">
        <div mat-sort-header="type">Document Type
          <fa-icon [icon]="sortIcon('type')"></fa-icon>
        </div>
        @if (documentTypeOptions.length > 0) {
          <mat-form-field>
            <mat-select
              [(value)]="documentFilters.type"
              (selectionChange)="applyFilters()"
              placeholder="Filter"
              multiple>
              @for (documentType of documentTypeOptions; track documentType) {
                <mat-option [value]="documentType">
                  {{ documentType }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </th>
      <td *matCellDef="let element" mat-cell class="column-large">
        {{ element.documentType.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th scope="col" *matHeaderCellDef mat-header-cell class="column-small">Actions</th>
      <td *matCellDef="let element" class="action-cell column-small" mat-cell>
        @if (!isReadAdmin && (activeSite.submittedDate === null || isAdmin)) {
          <div
            (click)="editDocument(element)"
            class="edit-icon">
            <fa-icon title="Edit Document" [icon]="['far', 'edit']" class="blue size-18"></fa-icon>
          </div>
        }
        <div (click)="downloadDocument(element, false)" class="open-icon">
          <fa-icon title="Download Document" [icon]="['far', 'download']" class="blue size-18"></fa-icon>
        </div>
        <div (click)="downloadDocument(element, true)" class="open-icon">
          <fa-icon
            title="Open in New Tab"
            [icon]="['far', 'arrow-up-right-from-square']"
            class="blue size-18"></fa-icon>
        </div>
        @if (!isReadAdmin && (activeSite.submittedDate === null || isAdmin)) {
          <div
            (click)="deleteDocument(element)"
            class="delete-icon">
            <fa-icon title="Delete Document" [icon]="['far', 'trash']" class="gray delete-icon size-18"></fa-icon>
          </div>
        }
      </td>
    </ng-container>
    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
  </table>
</div>
<input
  #documentUpload
  accept="{{ defaultFileTypes }}"
  id="documentUpload"
  name="documentUpload"
  style="display: none"
  type="file" />
@if (envelopes.length > 0 && (isAdmin || isReadAdmin)) {
  <div class="section-header">Docusign Envelopes</div>
  <div class="doc-list">
    <table [dataSource]="envelopes" class="fc-table" mat-table aria-describedby="List of Docusign Envelopes">
      <ng-container matColumnDef="sentDate">
        <th scope="col" *matHeaderCellDef mat-header-cell>Date Sent</th>
        <td *matCellDef="let element" mat-cell>
          <div class="doc-name">{{ element.sentDate | date: 'shortDate' }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th scope="col" *matHeaderCellDef mat-header-cell>Actions</th>
        <td *matCellDef="let element" class="action-cell" mat-cell>
          <div (click)="viewEnvelope(element)" class="open-icon">
            <fa-icon
              title="View Envelope"
              [icon]="['far', 'arrow-up-right-from-square']"
              class="blue size-18"></fa-icon>
          </div>
          @if (element.status === 'Sent' || element.status === 'Resent') {
            <div (click)="resendEnvelope(element)" class="open-icon">
              <fa-icon title="Resend Envelope" [icon]="['far', 'share']" class="blue size-18"></fa-icon>
            </div>
          }
          <div (click)="voidEnvelope(element)" class="delete-icon">
            <fa-icon title="Void Envelope" [icon]="['far', 'trash']" class="gray delete-icon size-18"></fa-icon>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th scope="col" *matHeaderCellDef mat-header-cell>Envelope Description</th>
        <td *matCellDef="let element" mat-cell>
          <div class="doc-name">{{ element.description }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="recipient">
        <th scope="col" *matHeaderCellDef mat-header-cell>Recipient Email</th>
        <td *matCellDef="let element" mat-cell>
          <div class="doc-name">{{ element.recipient }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th scope="col" *matHeaderCellDef mat-header-cell>Envelope Status</th>
        <td *matCellDef="let element" mat-cell>
          <div class="doc-name">{{ element.status }}</div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="envelopeColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: envelopeColumns" mat-row></tr>
    </table>
  </div>
}
